
import {Component, Vue, Prop} from 'vue-property-decorator';
@Component
export default class EchartsTooltip extends Vue {
    tooltipsType = '';
    tooltipsData = [];
    dateType = '';
    setData(params: any) {
        this.tooltipsType = params.tooltipsType;
        if (this.tooltipsType === 'teachingSituation') {
            this.tooltipsData = params.params;
        } else if (this.tooltipsType === 'workData') {
            this.tooltipsData = params.params.filter((item: any) => item.axisIndex === 0);
        } else {
            this.tooltipsData = params.value;
            this.dateType = params.dateType;
        }
    }
    formatTime(val: number) {
        let secondTime = val; // 秒
        let minuteTime = 0; // 分
        let hourTime = 0; // 小时
        if (secondTime > 60) {
            minuteTime = parseInt((secondTime / 60).toString());
            secondTime = parseInt((secondTime % 60).toString());
            if (minuteTime > 60) {
                hourTime = parseInt((minuteTime / 60).toString());
                minuteTime = parseInt((minuteTime % 60).toString());
            }
        }
        let result = '' + parseInt(secondTime.toString()) + '秒';

        if (minuteTime > 0) {
            result = '' + parseInt(minuteTime.toString()) + '分' + result;
        }
        if (hourTime > 0) {
            result = '' + parseInt(hourTime.toString()) + '小时' + result;
        }
        return result;
    }
}
